// extracted by css-extract-rspack-plugin
export default {"wrapper":"_cd42962","makerRows":"_2b483d18"};